import { cssThemedValue } from '@creditornot/cb-ingredients';
import styled from 'styled-components';

import { Typography as T, typographyCss } from 'common/typography';

export const Root = styled.div`
  display: flex;
  width: 100%;
  max-width: 650px;
  padding-block: 24px;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
  align-items: center;
  gap: 16px;
`;

export const SettingInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const SettingTitle = styled(T.Title2)``;

export const SettingDescription = styled(T.Body3)`
  color: ${cssThemedValue('textSecondary')};
`;

export const SettingHint = styled.div`
  ${typographyCss.Small}
  display: flex;
  align-items: center;
  gap: 8px;

  > svg {
    width: 12px;
    height: 12px;
  }
`;
